'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, type ReactNode } from 'react';
import { BriefcaseBusiness, ChartNoAxesCombined, ChevronDown, Megaphone, Video, type LucideIcon } from 'lucide-react';
import styles from './ServiceVerticalLandingPage.module.css';
import type { ServiceVerticalAccordionIcon } from './types';
const accordionIcons: Record<ServiceVerticalAccordionIcon, LucideIcon> = {
  briefcase: BriefcaseBusiness,
  chart: ChartNoAxesCombined,
  megaphone: Megaphone,
  video: Video
};
interface ServiceVerticalAccordionItemProps {
  blockId: string;
  label: string;
  icon?: ServiceVerticalAccordionIcon;
  children: ReactNode;
}
export function ServiceVerticalAccordionItem(t0) {
  const $ = _c(23);
  const {
    blockId,
    label,
    icon: t1,
    children
  } = t0;
  const icon = t1 === undefined ? "briefcase" : t1;
  const [isOpen, setIsOpen] = useState(false);
  const buttonId = `${blockId}-trigger`;
  const panelId = `${blockId}-panel`;
  const Icon = accordionIcons[icon];
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(_temp);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== Icon) {
    t3 = <span className={styles.accordionIcon} aria-hidden="true"><Icon size={27} strokeWidth={1.7} /></span>;
    $[1] = Icon;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== label) {
    t4 = <span className={styles.accordionLabel}>{label}</span>;
    $[3] = label;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isOpen ? "true" : "false";
  let t6;
  if ($[5] !== t5) {
    t6 = <ChevronDown className={styles.accordionChevron} data-open={t5} size={22} strokeWidth={3} aria-hidden="true" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== buttonId || $[8] !== isOpen || $[9] !== panelId || $[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className={`${styles.accordionHeader} faq-header`}><button id={buttonId} type="button" className={`${styles.accordionButton} faq-btn`} data-cms-field="label" aria-expanded={isOpen} aria-controls={panelId} onClick={t2}>{t3}{t4}{t6}</button></div>;
    $[7] = buttonId;
    $[8] = isOpen;
    $[9] = panelId;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = !isOpen;
  let t9;
  if ($[14] !== buttonId || $[15] !== children || $[16] !== panelId || $[17] !== t8) {
    t9 = <div id={panelId} className={`${styles.accordionBody} faq-body`} role="region" aria-labelledby={buttonId} hidden={t8}>{children}</div>;
    $[14] = buttonId;
    $[15] = children;
    $[16] = panelId;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== blockId || $[20] !== t7 || $[21] !== t9) {
    t10 = <div className={`${styles.accordionItem} faq-item`} data-cms-block-id={blockId}>{t7}{t9}</div>;
    $[19] = blockId;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(open) {
  return !open;
}